var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/core/callBridge.ts
import { XStorageError as XStorageError2 } from "@byted/tiktok-zti-storage-error";

// src/core/const.ts
var CONNECTION_IFRAME_MAIN_TIMEOUT = 120 * 1e3;
var CALLBRIDGE_TIMEOUT = 8 * 1e3;
var SECURE_KEYS = [
  "security-sdk/s_sdk_crypt_sdk",
  "security-sdk/s_sdk_cert_key",
  "security-sdk/s_sdk_sign_data_key/web_protect"
];

// src/core/util.ts
import { XStorageError } from "@byted/tiktok-zti-storage-error";

// src/version.ts
var version_default = "0.1.3";

// src/lib/getCDNURL.ts
import { isTopBrowser } from "@byted/tiktok-zti-storage-lib";
var isTB = isTopBrowser();
var PACKAGE_NAME = "@byted/tiktok-zti-storage-web";
var ORIGIN_DOMAIN = `https://www.tiktok.com`;
var ORIGIN_ASSETS_PREFIX = `${ORIGIN_DOMAIN}/obj/uc-assets/zt/`;
var ORIGIN_WEB_PREFIX = `${ORIGIN_DOMAIN}/obj/uc-web/zt/`;
var getCDNURL = (prefix, v, pageType) => {
  return `${prefix}${PACKAGE_NAME}/${v || version_default}/dist/${pageType || (isTB ? "latest" : "page")}/index.html`;
};
var getDefaultPageURL = (prefix, v) => {
  return getCDNURL(prefix || ORIGIN_ASSETS_PREFIX, v, "page");
};
var setFallbackVersion = (v) => {
  try {
    localStorage.setItem("X_STORAGE_FALLBACK_VERSION", v);
  } catch (e) {
  }
};
var getFallbackVersion = () => {
  try {
    return localStorage.getItem("X_STORAGE_FALLBACK_VERSION");
  } catch (e) {
  }
};
var getFallbackURL = () => {
  const fallbackVersion = getFallbackVersion();
  if (fallbackVersion) {
    return getCDNURL(ORIGIN_ASSETS_PREFIX, fallbackVersion);
  }
};

// src/core/global.ts
var win = window;
var addEvent = win.addEventListener;
var removeEvent = win.removeEventListener;
var loc = win.location;
var doc = document;
var isOriginEnv = () => {
  return process.env.NODE_ENV === "development" ? true : loc.origin === ORIGIN_DOMAIN;
};

// src/core/util.ts
var getCurrentTime = () => {
  return performance.now ? Number(performance.now().toFixed(0)) || Date.now() : Date.now();
};
var parseURLOrigin = (url) => {
  const array = url.split("//") || [];
  return `${array[0]}//${array[1].split("/")[0]}`;
};
var addURLQueryString = (url, queryString) => {
  return url.indexOf("html?") !== -1 ? `${url}&${queryString}` : `${url}?${queryString}`;
};
var inArrays = (array, targetArray) => {
  for (let i = 0; i < array.length; i++) {
    if (targetArray.indexOf(array[i]) === -1) {
      return false;
    }
  }
  return true;
};
var runSerialQueue = (queue, filter) => {
  let promise = Promise.reject(
    new XStorageError(`WebStorageRunSerialQueueError`)
  );
  for (let i = 0; i < queue.length; i++) {
    promise = promise.then((value) => {
      if (typeof filter === "function" && filter(value)) {
        return queue[i]();
      }
      if (typeof value === "undefined") {
        return queue[i]();
      }
      return value;
    }).catch(() => {
      return queue[i]();
    });
  }
  return promise;
};
var runSerialQueueIfOneResolve = (queue) => {
  let promise = Promise.reject(
    new XStorageError(`WebStorageRunSerialQueueIfOneResolveError`)
  );
  for (let i = 0; i < queue.length; i++) {
    if (queue[i]) {
      promise = promise.then((value) => {
        queue[i]().catch((e) => {
        });
        return value;
      }).catch((e) => {
        return queue[i]();
      });
    }
  }
  return promise;
};
var ID = `J_uc_iframe_box-${Date.now()}`;
var domReady = () => {
  const getBody = () => {
    return doc.body;
  };
  const iframeBox = () => {
    const box = document.getElementById(ID);
    if (box) {
      return box;
    }
    const div = document.createElement("div");
    div.style.display = "none";
    div.id = ID;
    doc.body.appendChild(div);
    return div;
  };
  return new Promise((resolve) => {
    const body = getBody();
    const res = {
      appendChild(node) {
        const box = iframeBox();
        box.appendChild(node);
      }
    };
    if (body) {
      resolve(res);
    } else if (doc.readyState === "loading") {
      doc.addEventListener("DOMContentLoaded", () => {
        resolve(res);
      });
    } else {
      resolve(res);
    }
  });
};

// src/core/messageLogDebug.ts
var debug = false;
var fn;
var openMessageLog = (client) => {
  if (!debug && client.config.debug) {
    debug = true;
    client.emit("debug", { name: "OpenMessageLog" });
    window.addEventListener(
      "message",
      fn = (event) => {
        const { data } = event;
        if (!debug) {
          return;
        }
        if (typeof data === "string" && data.indexOf("log:") === 0) {
          client.emit("debug", { name: `Message:Log=${data.substring(4)}` });
        } else {
        }
      }
    );
  }
};
var postMessageLog = (message) => {
  try {
    if (isOriginEnv()) {
      window.parent.postMessage(`log:${message}`, "*");
    }
  } catch (e) {
  }
};

// src/core/callBridge.ts
var reCallBridgeWhenTimeout = null;
var reCallBridgeMaxMessageId = -1;
var messageId = 0;
var createMessageIdString = (id) => {
  return `${id}`;
};
var POST_MESSAGE_MAP = {};
var callBridge = (client, retryReConnection = false, callTimeout = CALLBRIDGE_TIMEOUT) => {
  const oldPostMessage = client.postIframeMessage;
  const postMessage = (id, message) => {
    return oldPostMessage({ id, message });
  };
  return (callObj, callName, callArgs) => {
    let onTimeoutTimer;
    const $id = messageId++;
    const id = createMessageIdString($id);
    let hasTimeout = false;
    if (typeof callObj !== "string" || typeof callName !== "string") {
      return Promise.reject(
        new XStorageError2(`CallBridgeParameterError`, `callObj:${callObj}, callName:${callName}`)
      );
    }
    const response = () => {
      return client.window.then(() => {
        return new Promise((resolve, reject) => {
          const fn2 = (evt) => {
            const run2 = () => {
              const source = evt.data;
              if (source.id === id && POST_MESSAGE_MAP[id] && !POST_MESSAGE_MAP[id].et) {
                POST_MESSAGE_MAP[id]["et"] = getCurrentTime();
                client.emit("debug", { name: `BackPostMessageId=${id}` });
                clearTimeout(onTimeoutTimer);
                client.off("message", fn2);
                if (source.promiseStatus === "reject") {
                  reject(new XStorageError2(`${source.message || "UNKNOW_CallBridge_Error"}`));
                } else {
                  resolve(source.message);
                }
                delete POST_MESSAGE_MAP[id];
              }
            };
            try {
              run2();
            } catch (e) {
              reject(e);
            }
          };
          client.on("message", fn2);
          postMessage(id, { callObj, callName, callArgs }).catch(reject);
        });
      });
    };
    const run = (timeout) => {
      client.emit("debug", { name: `PostMessageId=${id}`, content: `${callObj}:${callName}` });
      POST_MESSAGE_MAP[id] = {};
      POST_MESSAGE_MAP[id]["st"] = getCurrentTime();
      return Promise.race([
        response(),
        new Promise((resolve, reject) => {
          onTimeoutTimer = setTimeout(() => {
            hasTimeout = true;
            POST_MESSAGE_MAP[id]["timeout"] = getCurrentTime();
            reject(
              new XStorageError2(
                `CallBridgeInvokeTimeout:${callObj}:${callName}`,
                `${JSON.stringify({
                  iframe: client.getIframeState(),
                  id
                })}`
              )
            );
          }, timeout);
        })
      ]);
    };
    return client.preCheck().then(() => {
      return run(callTimeout);
    }).catch((e) => {
      if (client.isConnection === true && retryReConnection && ((e == null ? void 0 : e.name) || "").indexOf("CallBridgeInvokeTimeout") !== -1) {
        const isTimeoutId = $id < reCallBridgeMaxMessageId;
        const $MessageId = messageId;
        client.emit("debug", {
          name: "reCallBridgeWhenTimeout",
          content: JSON.stringify({
            isTimeoutId,
            $MessageId,
            $id,
            callName,
            reCallBridgeWhenTimeout: Boolean(reCallBridgeWhenTimeout)
          })
        });
        reCallBridgeWhenTimeout = reCallBridgeWhenTimeout && isTimeoutId ? reCallBridgeWhenTimeout : new Promise((resolve) => {
          reCallBridgeMaxMessageId = $MessageId;
          openMessageLog(client);
          client.reStartConection("callBridge");
          resolve();
        });
        return reCallBridgeWhenTimeout.then(() => {
          return run(CALLBRIDGE_TIMEOUT);
        });
      }
      throw e;
    });
  };
};

// src/core/WebStorage.ts
import { CallEvent } from "@byted/tiktok-zti-call";
import DBStorage from "@byted/tiktok-zti-storage-idb";
import LStorage from "@byted/tiktok-zti-storage-local";
import MStorage from "@byted/tiktok-zti-storage-memory";
var { origin } = loc;
var WebStorage = class extends CallEvent {
  constructor(options) {
    super();
    this.dbSetFlag = [];
    /**
     * @memberof WebStorage
     * @method getItem
     * @description 获取指定键名的数据值，支持多个存储引擎，优先使用 localStorage。
     * @param {K} name - 键名。
     * @returns {Promise<T[K]>} - 返回一个 Promise 对象，表示异步取出的键值。
     * @template K
     */
    this.getItem = (name) => {
      return this.getItemByKeys([name]).then((res) => {
        return res[0];
      });
    };
    /**
     * @memberof WebStorage
     * @method setItem
     * @description 存储指定键名的数据值，支持多个存储引擎，优先使用 localStorage。
     * @param {K} name - 键名。
     * @param {T[K]} value - 键值。
     * @returns {Promise<T[K]>} - 返回一个 Promise 对象，表示异步操作完成的状态。
     * @template K
     */
    this.setItem = (name, value) => {
      return this.setItemByKeys([[name, value]]).then((res) => {
        return res[0];
      });
    };
    this.getItemByKeys = (keys) => {
      let from = -1;
      const dbsValues = [];
      return this.db.then((dbs) => {
        return runSerialQueue(
          dbs.map((db, index) => {
            return () => {
              return db["getItemByKeys"](keys).then((values) => {
                dbsValues[index] = keys.map((key, i) => {
                  return {
                    from: typeof values[i] !== "undefined" ? index : -1,
                    value: values[i],
                    origin
                  };
                });
                return values;
              });
            };
          }),
          (values) => {
            for (let i = 0; i < (values == null ? void 0 : values.length); i++) {
              if (typeof values[i] === "undefined") {
                return true;
              }
            }
            return false;
          }
        );
      }).catch((e) => {
        return this.fallbackDB.getItemByKeys(keys).then((items) => {
          from = 2;
          return items;
        });
      }).then((values) => {
        if (dbsValues[0]) {
          return dbsValues[0].map((item, index) => {
            return typeof item.value !== "undefined" ? item : dbsValues[1] ? dbsValues[1][index] ? typeof dbsValues[1][index].value === "undefined" ? item : dbsValues[1][index] : item : item;
          });
        } else if (dbsValues[1]) {
          return dbsValues[1];
        }
        return values.map((value) => {
          return { value, from, origin };
        });
      });
    };
    this.setItemByKeys = (pair) => {
      let from = -1;
      return this.db.then((dbs) => {
        return runSerialQueueIfOneResolve(
          dbs.map((db, index) => {
            return () => {
              return db.setItemByKeys(pair).then((rValue) => {
                from = index;
                return rValue;
              });
            };
          })
        ).catch((e) => {
          from = 2;
          return this.fallbackDB.setItemByKeys(pair);
        }).then((res) => {
          return res.map((value) => {
            return { value, from, origin };
          });
        });
      }).then(
        (res) => {
          return res;
        },
        (e) => {
          postMessageLog(`storage:setItemByKeys:error:${e == null ? void 0 : e.message}`);
          throw e;
        }
      );
    };
    /**
     * @memberof WebStorage
     * @method removeItem
     * @description 移除指定键名的数据，支持多个存储引擎，优先使用 localStorage。
     * @param {K} name - 键名。
     * @returns {Promise<void>} - 返回一个 Promise 对象，表示异步操作完成的状态。
     * @template K
     */
    this.removeItem = (name) => {
      return this.db.then((dbs) => {
        return Promise.all(
          dbs.map((db) => {
            return db.removeItem(name);
          })
        ).then(() => {
          return this.fallbackDB.removeItem(name);
        });
      });
    };
    this.config = options || {};
    const that = this;
    this.localDB = new LStorage();
    this.db = Promise.resolve([
      this.localDB,
      new DBStorage(__spreadProps(__spreadValues({}, (options == null ? void 0 : options.dbStorage) || {}), {
        onQuotaErrorCallback() {
          that.emit("log", { name: "QuotaError" });
        }
      }))
    ]);
    this.fallbackDB = new MStorage();
  }
  /**
   *
   * @description 获取Cache的Keys值
   */
  getKeys() {
    return this.db.then((dbs) => {
      return runSerialQueue(
        dbs.map((db) => {
          return () => {
            return db["getKeys"]();
          };
        }),
        (value) => {
          return typeof value === "undefined" || value.length === 0;
        }
      );
    });
  }
};

// src/core/WebCrossOriginStorage.ts
import { XStorageError as XStorageError5, createNSError } from "@byted/tiktok-zti-storage-error";

// src/core/WebCrossOriginSocket.ts
import { CallEvent as CallEvent3 } from "@byted/tiktok-zti-call";
import { XStorageError as XStorageError4 } from "@byted/tiktok-zti-storage-error";

// src/core/iframeConnection.ts
import { XStorageError as XStorageError3 } from "@byted/tiktok-zti-storage-error";
import { CallEvent as CallEvent2 } from "@byted/tiktok-zti-call";
var windowStatus = {
  get visibility() {
    return document.visibilityState;
  }
};
var POSTMESSAGE_FAIL_RETRY_MAX_COUNT = { current: 0, max: 2 };
var eventName = "visibilitychange";
var isHiddenWindow = () => {
  return document.visibilityState === "hidden";
};
var visibilityChange = () => {
  return new Promise((resolve) => {
    const fn2 = () => {
      if (!isHiddenWindow()) {
        document.removeEventListener(eventName, fn2);
        resolve(1);
      }
    };
    document.addEventListener(eventName, fn2);
  });
};
var IframeConnection = class extends CallEvent2 {
  constructor(config) {
    super();
    this.autoLoadIframeConfig = { max: 10, current: 0, iframeLoadPromise: null };
    this.reset = () => {
      const { autoLoadIframeConfig } = this;
      if (autoLoadIframeConfig.current >= autoLoadIframeConfig.max) {
        autoLoadIframeConfig.max += 10;
      }
      autoLoadIframeConfig.iframeLoadPromise = null;
      if (POSTMESSAGE_FAIL_RETRY_MAX_COUNT.current >= POSTMESSAGE_FAIL_RETRY_MAX_COUNT.max) {
        POSTMESSAGE_FAIL_RETRY_MAX_COUNT.max += 3;
      }
    };
    this.loadWindow = () => {
      const { url, ackTimeout } = this.config;
      const { autoLoadIframeConfig } = this;
      const ready = new Promise((resolve) => {
        const time = autoLoadIframeConfig.current === 0 ? 0 : 100;
        setTimeout(resolve, time);
      });
      return ready.then(() => {
        if (!url) {
          throw new Error(`URL Error`);
        }
        const targetURL = autoLoadIframeConfig.current === autoLoadIframeConfig.max ? addURLQueryString(url, `t=${Date.now()}`) : url;
        return this.createIframeElement(targetURL, ackTimeout);
      }).catch((e) => {
        if (autoLoadIframeConfig.current >= autoLoadIframeConfig.max) {
          if (isHiddenWindow()) {
            return visibilityChange().then(() => {
              return this.loadWindow().then((res) => {
                this.emit("log", { name: "visibilityChangeLoadWindowSuccuess" });
                return res;
              });
            });
          }
          const fallbackURL = getFallbackURL();
          if (fallbackURL) {
            this.emit("debug", { name: "StartFireFallbackURL", content: fallbackURL });
            return this.createIframeElement(fallbackURL, ackTimeout).then((res) => {
              this.emit("debug", { name: "EndFireFallbackURL", content: fallbackURL });
              res.fallback = true;
              return res;
            }).catch((ee) => {
              this.emit("debug", { name: "fireFallbackURLError", content: `${ee == null ? void 0 : ee.name}:${ee == null ? void 0 : ee.message}` });
              throw e;
            });
          }
          throw e;
        }
        autoLoadIframeConfig.current++;
        return this.loadWindow();
      });
    };
    this.createPostMessageFlight = (postMessageHandle, timeout = 3e3) => {
      const st = getCurrentTime();
      let timer;
      let et = st;
      const report = (statusValue) => {
        if (this.config.debug) {
          this.emit("metrics", {
            name: "PostMessageFlight",
            metrics: {
              startTime: st,
              endTime: et,
              loadTime: et - st
            },
            categories: {
              status: statusValue,
              retryCount: String(POSTMESSAGE_FAIL_RETRY_MAX_COUNT.current),
              version: version_default
            }
          });
        }
      };
      return Promise.race([
        new Promise((resolve, reject) => {
          const sid = `ACK_0_${Math.random()}`;
          const fn2 = (event) => {
            if (event.data === `ACK_1_${sid}`) {
              clearTimeout(timer);
              et = getCurrentTime();
              resolve();
              removeEvent("message", fn2);
            }
          };
          addEvent("message", fn2);
          try {
            postMessageHandle(sid);
          } catch (e) {
            reject(new XStorageError3(`PostMessageWindowError`, e == null ? void 0 : e.message));
          }
        }),
        new Promise((resolve, reject) => {
          timer = setTimeout(() => {
            et = getCurrentTime();
            reject(new XStorageError3(`PostMessageTimeout`));
          }, timeout);
        })
      ]).then(() => {
        report("1");
      }).catch((e) => {
        report("0");
        throw e;
      });
    };
    this.config = __spreadValues({
      ackTimeout: 2e3
    }, config || {});
  }
  setConfig(config) {
    this.config = {
      ackTimeout: config.ackTimeout || this.config.ackTimeout,
      url: config.url || this.config.url
    };
  }
  start() {
    const { autoLoadIframeConfig } = this;
    return autoLoadIframeConfig.iframeLoadPromise = autoLoadIframeConfig.iframeLoadPromise || this.loadWindow();
  }
  createIframeElement(url, timeout) {
    const ackTimeout = timeout || this.config.ackTimeout;
    const { autoLoadIframeConfig } = this;
    const startLoadTime = getCurrentTime();
    const iframe = doc.createElement("iframe");
    let endLoadTime = startLoadTime;
    let iframeWindow;
    let isAck = false;
    let onLoadTimer, onTimeoutTimer;
    let status = -1;
    iframe.style.display = "none";
    iframe.src = url;
    return domReady().then((body) => {
      const promise = Promise.race([
        new Promise((resolve, reject) => {
          iframe.onload = () => {
            endLoadTime = getCurrentTime();
            if (!isAck) {
              onLoadTimer = setTimeout(() => {
                if (!isAck) {
                  reject(
                    new XStorageError3(
                      "CreateIframeError",
                      JSON.stringify(__spreadProps(__spreadValues({
                        startTime: startLoadTime,
                        endTime: endLoadTime,
                        loadTime: endLoadTime - startLoadTime
                      }, windowStatus), {
                        current: autoLoadIframeConfig.current,
                        max: autoLoadIframeConfig.max
                      }))
                    )
                  );
                }
              }, ackTimeout || 2e3);
            }
          };
        }),
        new Promise((resolve, reject) => {
          const fn2 = (event) => {
            const run = () => {
              if (status === -1 && event.data === "ACK") {
                const origin2 = parseURLOrigin(url);
                if (origin2 === event.origin) {
                  isAck = true;
                  iframeWindow = event.source;
                  clearTimeout(onLoadTimer);
                  clearTimeout(onTimeoutTimer);
                  resolve();
                  removeEvent("message", fn2);
                }
              }
            };
            try {
              run();
            } catch (e) {
              reject(e);
            }
          };
          addEvent("message", fn2);
        }),
        new Promise((resolve, reject) => {
          onTimeoutTimer = setTimeout(() => {
            reject(new XStorageError3("CreateIframeMainTimeout"));
          }, CONNECTION_IFRAME_MAIN_TIMEOUT);
        })
      ]);
      body.appendChild(iframe);
      return promise;
    }).then(() => {
      return this.createPostMessageFlight((sid) => {
        const origin2 = parseURLOrigin(url);
        (iframe.contentWindow || iframeWindow).postMessage(sid, origin2);
      }).catch((e) => {
        if (e.name === "PostMessageWindowError") {
          if (POSTMESSAGE_FAIL_RETRY_MAX_COUNT.current < POSTMESSAGE_FAIL_RETRY_MAX_COUNT.max) {
            POSTMESSAGE_FAIL_RETRY_MAX_COUNT.current++;
            throw e;
          }
        } else {
          throw e;
        }
      });
    }).then(() => {
      if (iframe.parentNode) {
        status = 1;
        return {
          startTime: startLoadTime,
          endTime: getCurrentTime(),
          postMessage(message, targetOrigin) {
            (iframe.contentWindow || iframeWindow).postMessage(message, targetOrigin || "*");
          },
          destory: () => {
            var _a;
            try {
              (_a = iframe.parentNode) == null ? void 0 : _a.removeChild(iframe);
            } catch (e) {
            }
          },
          isValid() {
            var _a;
            return Boolean((iframe == null ? void 0 : iframe.parentNode) && ((_a = iframe == null ? void 0 : iframe.parentNode) == null ? void 0 : _a.parentNode));
          }
        };
      }
      throw new Error(`CreateIframeElementError`);
    }).catch((error) => {
      var _a;
      status = 0;
      try {
        (_a = iframe.parentNode) == null ? void 0 : _a.removeChild(iframe);
      } catch (e) {
      }
      try {
        if (error.name === "CreateIframeMainTimeout") {
          this.emit("debug", { name: "CreateIframeMainTimeout" });
        }
      } catch (e) {
      }
      throw error;
    });
  }
};

// src/core/WebCrossOriginSocket.ts
var createCallParentId = (id) => {
  return `p-${id}`;
};
var DEFAULT_ALLOW_ORIGIN = `.${location.origin.split(".").slice(-2).join(".")}`;
var WebCrossOriginSocket = class extends CallEvent3 {
  constructor(config) {
    super();
    this.config = {
      protocol: "Common"
    };
    this.loadTime = 0;
    this.startTime = 0;
    this.endTime = 0;
    this.callParentBridgetIndex = 0;
    this.listen = () => {
      if (window.parent !== window) {
        window.parent.postMessage("ACK", "*");
      }
    };
    this.getIframeState = () => {
      return {
        isConnection: typeof this.isConnection === "boolean" ? Number(Boolean(this.isConnection)) : -1,
        retryCount: this.iframeConnection.autoLoadIframeConfig.current,
        startTime: this.startTime,
        endTime: this.endTime,
        loadTime: this.loadTime,
        origin: location.origin
      };
    };
    this.postIframeMessage = (message) => {
      const { protocol } = this.config;
      if (this.window) {
        const { url } = this.config;
        return this.window.catch((e) => {
          return this.reConnection();
        }).then(({ target }) => {
          target.postMessage(
            {
              protocol,
              data: message
            },
            parseURLOrigin(url)
          );
        });
      }
      return Promise.reject(new XStorageError4(`postMessageError`));
    };
    this.postWindowMessage = (sourceWindow, type, message, targetOrigin = "*") => {
      const { protocol } = this.config;
      return new Promise((resolve) => {
        sourceWindow.postMessage(
          {
            type,
            protocol,
            data: message
          },
          targetOrigin
        );
        resolve();
      });
    };
    this.postParentMessage = (type, message, targetOrigin = "*") => {
      const windowParent = win.parent;
      if (windowParent !== win) {
        return this.postWindowMessage(windowParent, type, message, targetOrigin);
      }
      return Promise.resolve();
    };
    this.dispatchParentEvent = (eventName2, eventData) => {
      return this.postParentMessage("event", {
        id: createCallParentId(this.callParentBridgetIndex++),
        message: { eventName: eventName2, eventData }
      });
    };
    this.callParentBridge = (callObj, callName, callArgs) => {
      const id = createCallParentId(this.callParentBridgetIndex++);
      return Promise.race([
        new Promise((resolve, reject) => {
          const fn2 = (evt) => {
            const source = evt.data;
            if (source.id === id) {
              this.off("message", fn2);
              if (source.promiseStatus === "reject") {
                reject(new XStorageError4(`${source.message || "UNKNOW_CallParentBridge_Error"}`));
              } else {
                resolve(source.message);
              }
            }
          };
          this.on("message", fn2);
          this.postParentMessage("function", { id, message: { callObj, callName, callArgs } }).catch(
            reject
          );
        }),
        new Promise((resolve, reject) => {
          setTimeout(() => {
            reject(
              new XStorageError4(
                `CallParentBridgeInvokeTimeout`,
                `CallBridge invoke timeout: callObj=${callObj};callName=${callName};`
              )
            );
          }, 5e3);
        })
      ]);
    };
    this.startConnection = (type) => {
      const { url } = this.config;
      if (!this.window && url) {
        this.isStart = true;
        this.isConnection = void 0;
        this.emit("log", { name: `startConnection:${type}` });
        this.createConnection(url);
      }
    };
    this.reStartConection = (type) => {
      this.isStart = false;
      if (this.window) {
        this.window.then(({ target }) => {
          return target.destory();
        }).catch(() => {
        });
      }
      this.window = void 0;
      this.iframeConnection.reset();
      this.startConnection(type);
    };
    this.start = (config) => {
      return new Promise((resolve) => {
        this.config = __spreadValues(__spreadValues({}, this.config || {}), config || {});
        this.isStart = true;
        this.emit("config");
        resolve();
      });
    };
    this.reConnection = () => {
      const { url } = this.config;
      return this.createConnection(url);
    };
    this.preCheck = () => {
      if (this.isConnection && this.isStart && this.window) {
        return this.window.then(({ target }) => {
          if (!target.isValid()) {
            this.reStartConection("valid");
          }
        });
      }
      if (!this.config.disablePreCheckConnection && this.isConnection === false && this.iframeConnection.autoLoadIframeConfig.current >= this.iframeConnection.autoLoadIframeConfig.max) {
        this.reStartConection("reConnection");
      }
      return Promise.resolve();
    };
    this.onMessage = (event) => {
      var _a, _b, _c, _d;
      const throwPostMessageError = (code, message) => {
        var _a2;
        try {
          (_a2 = event.source) == null ? void 0 : _a2.postMessage(`SOCKET_ERROR_${code}@${message}`, event.origin);
        } catch (ee) {
        }
      };
      try {
        const { url, protocol, allowOrigin = [] } = this.config;
        const isIframeOrigin = url ? parseURLOrigin(url) === event.origin : false;
        const isAllowOrigin = url ? isIframeOrigin : Boolean(
          [DEFAULT_ALLOW_ORIGIN, ...allowOrigin].filter((oItem) => {
            return event.origin.lastIndexOf(oItem) !== -1;
          })[0]
        );
        try {
          if (!event.origin) {
            this.emit("debug", { name: "eventLostOrigin", content: JSON.stringify(event.data || {}) });
          }
        } catch (e) {
        }
        if (isAllowOrigin) {
          if (typeof event.data === "string" && event.data.indexOf("ACK_0_") === 0) {
            try {
              (_a = event.source) == null ? void 0 : _a.postMessage(`ACK_1_${event.data}`, event.origin);
            } catch (e) {
            }
          } else if (((_b = event.data) == null ? void 0 : _b.protocol) === protocol) {
            try {
              this.emit("message", {
                type: (_c = event.data) == null ? void 0 : _c.type,
                data: (_d = event.data) == null ? void 0 : _d.data,
                origin: event.origin,
                sourceWindow: event.source
              });
            } catch (e) {
              throwPostMessageError(500, JSON.stringify(event.data));
              this.emit("debug", {
                name: `postMessage:protocol:error:${e == null ? void 0 : e.message}`
              });
            }
          }
        } else {
        }
      } catch (error) {
        throwPostMessageError(501, `${error.message}`);
        this.emit("debug", { name: "SomePostMessageEventError", content: error == null ? void 0 : error.message });
      }
    };
    this.initMessageEvent = () => {
      this.removeMessageEvent();
      window.addEventListener("message", this.onMessage);
      this.emit("debug", { name: "initMessageEvent" });
    };
    this.removeMessageEvent = () => {
      window.addEventListener("message", this.onMessage);
    };
    this.config = __spreadValues(__spreadValues({}, this.config), config || {});
    this.iframeConnection = new IframeConnection();
    this.startConnection("init");
    this.on("config", () => {
      this.startConnection("config");
    });
    this.initMessageEvent();
    this.on("connection", (context) => {
      this.loadTime = context.endTime - context.startTime;
      this.startTime = context.startTime;
      this.endTime = context.endTime;
      this.isConnection = true;
      if (this.config.enableFallback && !context.target.fallback) {
        setFallbackVersion(version_default);
      }
      this.emit("debug", { name: "ConnectionSuccess" });
      this.initMessageEvent();
    });
    this.iframeConnection.on("debug", (source) => {
      this.emit("debug", source);
    });
    this.iframeConnection.on("log", (source) => {
      this.emit("log", source);
    });
    this.iframeConnection.on("metrics", (source) => {
      this.emit("metrics", source);
    });
    this.on("connectionFail", (err) => {
      const { downgradeCSPURL } = this.config;
      this.isConnection = false;
      this.emit("error", new XStorageError4(`Connection:${err.name}`, err.message));
      this.emit("debug", { name: "connectionFail" });
      if (downgradeCSPURL && (err == null ? void 0 : err.message.indexOf("Content Security Policy")) !== -1) {
        const url = typeof downgradeCSPURL === "string" ? downgradeCSPURL : getDefaultPageURL();
        if (url && this.config.url !== url) {
          this.emit("debug", { name: `fireDefaultPageURL`, content: url });
          this.config.url = url;
          this.reStartConection("csp");
        }
      }
    });
    addEvent("message", (event) => {
      if (typeof event.data === "string") {
        if (event.data.indexOf("SOCKET_ERROR_") !== -1) {
          this.emit("error", new XStorageError4(`SCOKET_ERROR`, event.data));
        } else if (event.data.indexOf("Version:") !== -1) {
          this.emit("debug", { name: "SocketVersion", content: event.data.split(":")[1] });
        }
      }
    });
  }
  createConnection(url) {
    const { ackTimeout } = this.config;
    const startTime = getCurrentTime();
    const { max } = this.iframeConnection.autoLoadIframeConfig;
    this.iframeConnection.setConfig({ url: max > 10 ? addURLQueryString(url, `t=${max}`) : url, ackTimeout });
    const thisWindow = this.iframeConnection.start().then((iWindow) => {
      const endTime = getCurrentTime();
      const context = {
        target: iWindow,
        startTime,
        endTime
      };
      this.emit("connection", __spreadValues({}, context));
      return context;
    }).catch((e) => {
      this.emit("connectionFail", new XStorageError4(`${e.name || "ConnectionError"}`, e.message));
      throw e;
    });
    return this.window = thisWindow;
  }
};

// src/lib/promise.ts
var promiseFinally = (promise) => {
  return (fn2) => {
    return promise.then(
      (value) => {
        return Promise.resolve(fn2()).then(() => {
          return value;
        });
      },
      (reason) => {
        return Promise.resolve(fn2()).then(() => {
          throw reason;
        });
      }
    );
  };
};

// src/core/WebCrossOriginStorage.ts
import { CallEvent as CallEvent4 } from "@byted/tiktok-zti-call";
var WebCrossOriginStorage = class extends CallEvent4 {
  constructor(config) {
    super();
    this.listen = () => {
      this.client.listen();
    };
    this.setConfig = (config) => {
      return new Promise((resolve) => {
        this.config = __spreadValues(__spreadValues({}, this.config || {}), config);
        this.emit("config", this.config);
        resolve();
      });
    };
    // 外层调用
    this.startStorageChecker = () => {
      return new Promise((resolve) => {
        if (this.client.isConnection) {
          resolve();
        } else {
          this.client.on("connection", () => {
            resolve();
          });
        }
      }).then(() => {
        return callBridge(this.client, true, 3 * 1e3)("config", "startChecker", []);
      });
    };
    // iframe里面调用 回传给iframe
    this.startChecker = () => {
      return new Promise((resolve, reject) => {
        const { startStorageCheckerCallBack } = this.config || {};
        startStorageCheckerCallBack == null ? void 0 : startStorageCheckerCallBack();
        resolve();
      });
    };
    this.setOriginStorageConfig = (config) => {
      return new Promise((resolve) => {
        if (this.client.isConnection) {
          resolve();
        } else {
          this.client.on("connection", () => {
            resolve();
          });
        }
      }).then(() => {
        const { url } = this.client.config;
        if (url) {
          return callBridge(this.client, true, 30 * 1e3)("config", "setConfig", [config]);
        }
        throw new Error(`NoOriginStorageURL`);
      });
    };
    this.setItem = (name, value, options) => {
      return this.setItemByKeys([[name, value]], options).then((values) => {
        return values[0];
      });
    };
    this.getItem = (name, options) => {
      return this.getItemByKeys([name], options).then((values) => {
        return values[0];
      });
    };
    this.getItemByKeys = (keys, options) => {
      const { async, logger = true } = options || {};
      let startTime = getCurrentTime();
      let endTime = 0;
      let startCallTime = 0;
      let status = -1;
      let info = {};
      let report = () => {
        if (!logger)
          return;
        try {
          endTime = endTime || getCurrentTime();
          startCallTime = startCallTime || endTime;
          this.emit("metrics", {
            name: "getOriginItemByKeys",
            metrics: {
              duration: endTime - startTime,
              callTime: endTime - startCallTime,
              startCallTime,
              startTime,
              endTime
            },
            categories: __spreadValues({
              status: String(status)
            }, info)
          });
        } catch (e) {
        }
      };
      const createInfo = (res) => {
        status = status > -1 ? status : 1;
        try {
          res.forEach((item, index) => {
            const types = ["from", "origin", "status", "code"];
            types.forEach((type) => {
              const keyString = keys[index];
              const keyStrings = keyString.split("/");
              const result = type === "status" ? String(item.value ? 1 : 0) : String(item[type]);
              if (result !== "undefined") {
                info[`${keyStrings[1] || keyString}_${type}`] = result;
              }
            });
          });
        } catch (e) {
        }
      };
      const getTask = () => {
        const { url } = this.client.config;
        startCallTime = getCurrentTime();
        const callBridgeGetItem = () => {
          return callBridge(this.client)("storage", "getItemByKeys", [keys]).then((values) => {
            endTime = getCurrentTime();
            status = 2;
            return Promise.all(
              values.map((item, index) => {
                if (typeof item.value === "undefined") {
                  status = 3;
                }
                return typeof item.value === "undefined" ? this.storage.getItem(keys[index]) : item;
              })
            );
          });
        };
        if (url) {
          if (typeof async !== "undefined") {
            return Promise.race([
              callBridgeGetItem(),
              new Promise((resolve) => {
                setTimeout(resolve, typeof async === "number" ? async : 1e3);
              }).then(() => {
                return this.storage.getItemByKeys(keys);
              })
            ]);
          }
          return runSerialQueueIfOneResolve([
            callBridgeGetItem,
            () => {
              return this.storage.getItemByKeys(keys).then((res) => {
                return res.map((item) => {
                  item.code = 1001;
                  return item;
                });
              });
            }
          ]);
        }
        return this.storage.getItemByKeys(keys);
      };
      const run = () => {
        return promiseFinally(
          getTask().catch(() => {
            return this.storage.getItemByKeys(keys);
          }).then((res) => {
            createInfo(res);
            return res;
          }).catch((e) => {
            status = 0;
            throw e;
          })
        )(report);
      };
      return this.getLocalItemWithSignByKeys(keys).then(({ values, st, et }) => {
        startTime = st;
        endTime = et;
        status = 12;
        createInfo(values);
        report();
        return values;
      }).catch(() => {
        return run();
      });
    };
    this.setItemByKeys = (items, options) => {
      const { async, logger = true } = options || {};
      const startTime = getCurrentTime();
      let endTime = 0;
      let status = -1;
      let retryCount = 0;
      let startCallTime = 0;
      let info = {};
      let report = () => {
        if (!logger)
          return;
        try {
          endTime = endTime || getCurrentTime();
          this.emit("metrics", {
            name: "setOriginItemByKeys",
            metrics: {
              duration: endTime - startTime,
              callTime: endTime - startCallTime,
              startCallTime,
              startTime,
              endTime,
              retryCount
            },
            categories: __spreadValues({
              status: String(status)
            }, info)
          });
        } catch (e) {
        }
      };
      let startReportRef = {
        end: false,
        sync: false,
        resolve: () => {
        }
      };
      const createInfo = (res) => {
        status = status > -1 ? status : 1;
        try {
          res.forEach((item, index) => {
            const types = ["from", "origin", "status"];
            types.forEach((type) => {
              const keyString = items[index][0];
              const keyStrings = keyString.split("/");
              info[`${keyStrings[1] || keyString}_${type}`] = type === "status" ? String(item.value ? 1 : 0) : String(item[type]);
            });
          });
        } catch (e) {
        }
      };
      new Promise((resolve) => {
        startReportRef.resolve = resolve;
      }).then(report);
      let startReport = (key) => {
        startReportRef[key] = true;
        if (startReportRef["end"] && startReportRef["sync"]) {
          startReportRef.resolve();
        }
      };
      const exec = (oItems) => {
        const { url } = this.client.config;
        startCallTime = getCurrentTime();
        const callBridgeSetItemByKeys = (timeout) => {
          return callBridge(this.client, true, timeout)("storage", "setItemByKeys", [oItems]).then((res) => {
            status = 2;
            createInfo(res);
            endTime = getCurrentTime();
            return res;
          });
        };
        if (url) {
          if (typeof async !== "undefined") {
            return Promise.race([
              promiseFinally(
                callBridgeSetItemByKeys(30 * 1e3).catch((e) => {
                  const errorMessage = `${e == null ? void 0 : e.name}@${e == null ? void 0 : e.message}`;
                  retryCount++;
                  return callBridgeSetItemByKeys().catch((ee) => {
                    this.emit("log", {
                      name: "callBridgeSetItemByKeysRetryError",
                      content: JSON.stringify({
                        iframe: this.client.getIframeState(),
                        errorMessage
                      })
                    });
                    throw e;
                  });
                })
              )(startReport.bind(null, "sync")),
              new Promise((resolve) => {
                setTimeout(resolve, typeof async === "number" ? async : 1e3);
              }).then(() => {
                return this.storage.setItemByKeys(oItems);
              })
            ]);
          }
          return runSerialQueueIfOneResolve([
            () => {
              return promiseFinally(callBridgeSetItemByKeys())(startReport.bind(null, "sync"));
            },
            () => {
              return this.storage.setItemByKeys(oItems);
            }
          ]);
        }
        return this.storage.setItemByKeys(oItems);
      };
      return promiseFinally(
        exec(items).catch(() => {
          return this.storage.setItemByKeys(items);
        }).catch((e) => {
          status = 0;
          throw e;
        }).then((res) => {
          createInfo(res);
          return res;
        })
      )(startReport.bind(null, "end"));
    };
    this.removeItem = (name) => {
      const { url } = this.client.config;
      if (url) {
        return Promise.all([
          this.storage.removeItem(name),
          callBridge(this.client)("storage", "removeItem", [name])
        ]).then(() => {
        });
      }
      return this.storage.removeItem(name);
    };
    /**
     * @description 如果有验签逻辑：先从本地获取，如果有则返回，如果没有，则走原有逻辑
     */
    this.getLocalItemWithSignByKeys = (keys) => {
      var _a;
      if (((_a = this.sign) == null ? void 0 : _a.verify) && inArrays(keys, SECURE_KEYS)) {
        const st = getCurrentTime();
        return this.storage.localDB.getItemByKeys(SECURE_KEYS).then((values) => {
          return this.sign.verify(values).then((isOk) => {
            if (isOk) {
              return keys.map((key) => {
                return {
                  value: values[SECURE_KEYS.indexOf(key)],
                  origin: location.origin,
                  from: 0,
                  code: 304
                };
              });
            }
            throw new Error("VerifySignFail");
          }).then((res) => {
            const et = getCurrentTime();
            return {
              values: res,
              st,
              et
            };
          });
        });
      }
      return Promise.reject(new Error(`NotVerifySignFunction`));
    };
    this.initBirdgeEvent = () => {
      this.client.on("message", ({ data, origin: origin2, type, sourceWindow }) => {
        const { id } = data || {};
        if (type === "event") {
          const { eventName: eventName2, eventData } = data.message || {};
          if (eventName2 === "error") {
            this.emit("error", new XStorageError5(eventData.name, eventData.message, eventData.origin));
          } else if (eventName2 === "log") {
            return this.emit("log", eventData);
          }
        } else {
          const { callObj, callName, callArgs = [] } = data.message || {};
          const postMessage = (promiseStatus, message) => {
            return this.client.postWindowMessage(
              sourceWindow,
              "function",
              {
                id,
                promiseStatus,
                message
              },
              origin2
            );
          };
          if (["storage", "storageX", "client", "sign", "config", "logger"].indexOf(callObj) !== -1) {
            try {
              postMessageLog(`${callObj}-${callName}`);
              (["storage", "config"].indexOf(callObj) !== -1 ? this : this[callObj])[callName].apply(this, callArgs).then(postMessage.bind(null, "resolve")).catch((error) => {
                postMessage("reject", error.name || error.message || "UnknowMessageError").catch(() => {
                });
              });
            } catch (e) {
              postMessage("reject", "UnknowMessageError").catch(() => {
              });
            }
          }
        }
      });
    };
    this.config = __spreadValues({ debug: false, hostname: location.hostname }, config || {});
    this.client = new WebCrossOriginSocket(__spreadProps(__spreadValues({}, this.config.scoket || {}), {
      protocol: this.config.protocol,
      allowOrigin: this.config.allowOrigin,
      debug: this.config.debug,
      url: this.config.url
    }));
    this.storage = new WebStorage(this.config.storage);
    this.storageX = this.storage;
    if (this.config.verifySignMethod) {
      this.sign = __spreadProps(__spreadValues({}, this.sign || {}), {
        verify: (args) => {
          return Promise.resolve(this.config.verifySignMethod(args));
        }
      });
    }
    this.logger = {
      metrics: (data) => {
        this.emit("metrics", data);
        return Promise.resolve();
      }
    };
    this.initBirdgeEvent();
    this.on("error", (err) => {
      if (!this.config.disableReportLogger) {
        this.client.dispatchParentEvent("error", { name: err.name, message: err.message, origin: err.origin }).catch(() => {
        });
      }
    });
    this.on("log", (source) => {
      if (!this.config.disableReportLogger) {
        this.client.dispatchParentEvent("log", source).catch(() => {
        });
      }
    });
    this.on("debug", (source) => {
      if (this.config.debug) {
        this.emit("log", __spreadProps(__spreadValues({}, source), {
          name: `Debug:${source.name}`
        }));
      }
    });
    this.client.on("error", (err) => {
      err.name = `Socket:${err.name}`;
      this.emit("error", err);
    });
    this.storage.on("error", (err) => {
      this.emit("error", createNSError("WebStorage", err));
    });
    this.storage.on("log", (source) => {
      this.emit("log", source);
    });
    this.client.on("log", (source) => {
      this.emit("log", source);
    });
    this.client.on("metrics", (source) => {
      this.emit("metrics", source);
    });
    this.client.on("debug", (source) => {
      this.emit("debug", source);
    });
    this.client.start().catch((e) => {
      this.emit("error", new XStorageError5(`StartSocketClientError`, e.message));
    });
  }
};
export {
  WebCrossOriginStorage,
  WebStorage,
  callBridge,
  getCDNURL,
  isTopBrowser,
  version_default as version
};
